import { Grid, Paper } from "@mantine/core";
import React, { useState } from "react";
import Intercom from "../components/integrations/intercom";
import OpenAI from "../components/integrations/open_ai";
import Retell from "../components/integrations/retell";
import Sendgrid from "../components/integrations/sendgrid";
import Stripe from "../components/integrations/stripe";
import Twilio from "../components/integrations/twilio";
import Scripts from "../components/integrations/scripts";
import Telnyxes from "../components/integrations/telnyxes";

export default function WLIntegrations() {
    const [selectedItem, setSelectedItem] = useState<string | null>(null);

    return <div style={{ position: 'relative' }}>
        <Grid>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Twilio connectOnly default />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Telnyxes connectOnly default />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <OpenAI />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Intercom />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Retell />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Sendgrid />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Stripe />
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper p="md" shadow="md">
                    <Scripts />
                </Paper>
            </Grid.Col>
        </Grid>
    </div>
}
